import React, { useState } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import Mask from './Mask';

const MainImage = (props) => {
    const { content, currentIndex, action, setCurrentIndex, setAction } = props;
    
    const [ isShowMask, setIsShowMask ] = useState(false);
    const [ videoUrl, setVideoUrl ] = useState('');

    const toggleIsShowMask = () => {
        if (isShowMask) {
            setVideoUrl('');
        }
        setIsShowMask(!isShowMask);
    };

    const showMask = (videoUrl) => {
        toggleIsShowMask();
        setVideoUrl(videoUrl);

        const videoWp = document.getElementById('video_wp');

        videoWp.style.width = `${window.innerHeight * 0.8 * 16 / 9}px`;
        videoWp.style.height = `${window.innerHeight * 0.8}px`;
    };

    const handlePrev = () => {
        const res = currentIndex - 1;

        if (res < 0) {
            return;
        }

        setCurrentIndex(res);
        setAction('prev');
    };

    const handleNext = () => {
        const res = currentIndex + 1;

        if (res >= content.length) {
            return;
        }

        setCurrentIndex(res);
        setAction('next');
    };

    const handleWheel = (e) => {
        const { deltaY } = e;

        if (deltaY > 0) {
            handleNext();
        } else {
            handlePrev();
        }
    };

    return (
        <div className={`${styles.slide_wp} ${styles[action]}`} onWheel={handleWheel}>
            {
                content.map((item, index) => {
                    return (
                        <div key={index} className={`${styles.slide} ${currentIndex === index ? styles.active : ''}`}>
                            {
                                index === 0 &&
                                <>
                                    <img className={styles.descImg} src="https://x0.ifengimg.com/ucms/2022_19/FAC0502EBF458A924E2C87E8479EE92A69BB6A9C_size126_w1920_h914.png" alt="" />
                                </>
                            }
                            <img src={item.img} alt="" />
                            {
                                item.videoUrl &&
                                <div className={styles.playBtn} onClick={() => showMask(item.videoUrl)}>
                                    <img src="http://y0.ifengimg.com/l/2016/14/ee68a6a69b33785/sp_we.png" alt="" />
                                </div>
                            }
                        </div>
                    );
                })
            }
            {/* 箭头 */}
            <div className={`${styles.btn} ${styles.prev}`} onClick={handlePrev}><img src="https://x0.ifengimg.com/ucms/2022_19/B91759618DECE92AD81A98FCAC8050E72B364409_size13_w124_h238.png" alt="" /></div>
            <div className={`${styles.btn} ${styles.next}`} onClick={handleNext}><img src="https://x0.ifengimg.com/ucms/2022_19/4FFF180E289D87BCA0B27B5EAB86FF81225B7193_size13_w124_h238.png" alt="" /></div>

            <Mask visible={isShowMask} videoUrl={videoUrl} onClose={toggleIsShowMask} />
        </div>
    );
};

MainImage.propTypes = {
    content: PropTypes.array,
    currentIndex: PropTypes.number,
    action: PropTypes.string,
    setCurrentIndex: PropTypes.func,
    setAction: PropTypes.func
};

export default errorBoundary(MainImage);
